module.exports = __webpack_public_path__ + "img/radio_pause.f53479ab.svg";